import { render, staticRenderFns } from "./ThemeProvider.vue?vue&type=template&id=16958ae5&scoped=true&"
import script from "./ThemeProvider.vue?vue&type=script&lang=ts&"
export * from "./ThemeProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeProvider.vue?vue&type=style&index=0&id=16958ae5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16958ae5",
  null
  
)

export default component.exports